var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3847 5.97595C12.3847 5.97595 11.9676 11.3679 11.7325 13.6319C11.7186 14.1065 11.5275 14.5561 11.2007 14.8828C10.874 15.2094 10.4382 15.3867 9.98816 15.376H9.94263C7.96322 15.376 5.98382 15.416 4.0044 15.376C3.56236 15.3911 3.13256 15.2214 2.80867 14.9037C2.48477 14.586 2.29303 14.1461 2.27526 13.68C2.03257 11.392 1.62305 6.01599 1.62305 6.01599",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4308 3.39197H0.538086",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9513 3.39197C10.6634 3.39225 10.3843 3.28709 10.1616 3.09451C9.93893 2.90193 9.78649 2.63382 9.7303 2.33592L9.5407 1.35994C9.48695 1.14218 9.36621 0.949441 9.19738 0.811893C9.02855 0.674345 8.82121 0.599806 8.60789 0.599979H5.39986C5.18557 0.599402 4.97713 0.673637 4.80702 0.811112C4.63691 0.948586 4.5147 1.14153 4.45946 1.35994L4.26986 2.33592C4.21367 2.63382 4.06123 2.90193 3.83856 3.09451C3.61589 3.28709 3.33677 3.39225 3.04883 3.39197",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDelete);
export default __webpack_public_path__ + "static/media/chat_delete.d4e971aa9ef458ca90334b032cf8df99.svg";
export { ForwardRef as ReactComponent };